import { docLayoutTemplate } from './doc-layout/src/template';

export default {
  layout: docLayoutTemplate,
};
